import React from 'react';
import ErrorPage from './ErrorPage.js';

const Unauthorized = () => (
  <ErrorPage
    code="401"
    title="Unauthorized"
    message="You need to sign in to access this page."
  />
);

export default Unauthorized;
